import { IChannel } from '../models/ichannel';
import { ITraceData } from '../models/interfaces';

export class TraceData implements ITraceData {
    originalChannel: IChannel | null = null;
    derivedChannel: IChannel | null = null;
    markers = new Array<number>();
}
